import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import Card from "./card.js";
var ImageOnly = /*#__PURE__*/function (_Card) {
  _inherits(ImageOnly, _Card);
  var _super = _createSuper(ImageOnly);
  function ImageOnly(s, t, i, h, l, r, e, n, o, u, a, c, d) {
    var _this;
    _classCallCheck(this, ImageOnly);
    _this = _super.call(this, s, t, null, i, null, h, l, r, null, e, n, o, u, a, c, d), _this.Xt = "ab-image-only", _this.Yt = !1, _this.test = !1;
    return _this;
  }
  _createClass(ImageOnly, [{
    key: "dt",
    value: function dt() {
      var s = {};
      return s[Card.ss.ts] = Card.es.Ii, s[Card.ss.rs] = this.id, s[Card.ss.os] = this.viewed, s[Card.ss.ns] = this.imageUrl, s[Card.ss.ps] = this.updated, s[Card.ss.us] = this.expiresAt, s[Card.ss.URL] = this.url, s[Card.ss.fs] = this.aspectRatio, s[Card.ss.xs] = this.extras, s[Card.ss.bs] = this.pinned, s[Card.ss.gs] = this.dismissible, s[Card.ss.js] = this.clicked, s[Card.ss.zs] = this.language, s[Card.ss.ks] = this.altImageText, s[Card.ss.qs] = this.test, s;
    }
  }]);
  return ImageOnly;
}(Card);
export { ImageOnly as default };